import React from "react"
import WingsCardContainer from "./WingsCardContainer"
import WingsCardDetail from "./WingsCardDetail"
import { WingsQuoteText } from "../typography"
import { WingsHeading } from "../typography"
import { useIntl } from "react-intl"
import { useCareers } from "../../../../components/assessment/useCareers"
import { demandTranslations } from "../../../../utils"
import { FormattedMessage } from "react-intl"
import { calcMatchStrength } from "../../../../components/assessment/utils/utils"

const taleRecommendationLabels = {
  "stay steady": <FormattedMessage id="career-card-stay-steady" defaultMessage="Stay Steady" />,
  "change course": <FormattedMessage id="career-card-change-course" defaultMessage="Change Course" />,
}

const personalityMatchLabels = {
  "Excellent": {
    text: <FormattedMessage id="career-card-excellent" defaultMessage="Excellent" />,
    color:  "var(--w-color-orange-500)",
  },
  "Good": {
    text: <FormattedMessage id="career-card-good" defaultMessage="Good" />,
    color:  "var(--w-color-orange-300)", // maybe 400?
  },
  "Fair": {
    text: <FormattedMessage id="career-card-fair" defaultMessage="Fair" />,
    color:  "var(--w-color-orange-100)",
  },
}

const WingsCareerCard = ({
  img,
  title,
  slug,
  salaryEntry,
  salaryExperienced,
  demand,
  category,
  objectID,
  contentType = "careers",
  careerQuote,
  careerQuoteCite,
  onDislike,
  correlation = 0,
  recommendationLabel = "",
  onImageButtonClick,
}) => {
  const { locale, formatMessage } = useIntl()
  const imageButtonLabel = onImageButtonClick
    ? formatMessage({ id: "career-plans-view-plans", defaultMessage: "View Plans" })
    : null

  const allCosmicjsCareers = useCareers(locale)
  const matchedCareer = allCosmicjsCareers.find(career => career.slug === slug)
  const personalityMatchLabel = personalityMatchLabels[calcMatchStrength(correlation)]

  return (
    <WingsCardContainer
      imageUrl={img && `${img}?q=&auto=compress,&w=712&h=446&fit=crop`}
      imageAlt={title ? `${title} career` : 'Career image'}
      title={title}
      to={`/career/${slug}`}
      subtitle={category}
      objectID={objectID}
      slug={slug}
      contentType={contentType}
      jobCategories={matchedCareer?.career_job_categories}
      careerPathwaysFilter={matchedCareer?.career_pathways_filter}
      leftLabel={taleRecommendationLabels[recommendationLabel]}
      rightLabel={personalityMatchLabel?.text}
      rightLabelColor={personalityMatchLabel?.color}
      onDislike={onDislike}
      imageButtonLabel={imageButtonLabel}
      onImageButtonClick={onImageButtonClick}
    >
      {((salaryEntry && salaryExperienced) || demand) && (
        <div className="w-flex w-flex-column w-justify-start w-items-start w-gap-xs">
          {(salaryEntry && salaryExperienced) && (
            <WingsCardDetail
              label={formatMessage({id: "cards-careers-salary", defaultMessage:"Salary"})}
              value={` $${salaryEntry} - $${salaryExperienced}`}
            />
          )}
          {demand && (
            <WingsCardDetail
              label={formatMessage({id: "cards-careers-demand", defaultMessage:"Demand"})}
              value={` ${demandTranslations[demand][locale] || demand}`}
            />
          )}
        </div>
      )}
      {careerQuote && (
        <>
        <WingsQuoteText size="small" className="w-m-0">
          &ldquo;{careerQuote}&rdquo;
        </WingsQuoteText>
        {careerQuoteCite && (
          <WingsHeading level={6}>
            {`— ${careerQuoteCite}`}
          </WingsHeading>
        )}
        </>
      )}
    </WingsCardContainer>
  )
}

export default WingsCareerCard
